
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.665 6.247a1.018 1.018 0 010 1.51l-5.713 5.33a1.203 1.203 0 01-1.617 0 1.018 1.018 0 010-1.509L5.24 7 .338 2.422a1.018 1.018 0 010-1.51 1.203 1.203 0 011.618 0l5.713 5.332-.004.003z","fill":"#348EF6"}})])
          )
        }
      }
    